import React from 'react';

function planillacambio() {
    // Función para manejar las descargas
    const descargarPlanilla = (archivo) => {
        // Crear un enlace temporal para descargar el archivo
        const enlace = document.createElement('a');
        enlace.href = archivo;
        enlace.download = archivo.split('/').pop(); // Obtener el nombre del archivo desde la URL
        enlace.click();
    };

    return (
        <div className="max-w-4xl mx-auto p-6 text-center bg-gradient-to-b from-green-800 to-white">
       
            <h1 className="text-3xl font-bold text-white mb-6">  Planillas de Baja  </h1>
            <p>Imprimir y traer a administracion  </p>
            <p>Santiago del Estero 666</p>
            <div className="space-y-4">
                <button onClick={() => descargarPlanilla(' ./assets/planillas/baja debito.pdf')}
                    className="px-6 py-3 bg-green-600 text-black rounded-lg hover:bg-green-700 space-y-6">
                    Descargar Planilla Baja Debito
                </button>
                <button onClick={() => descargarPlanilla(' ./assets/planillas/baja ingles.pdf')}
                    className="px-6 py-3 bg-green-600 text-black rounded-lg hover:bg-green-700 space-y-6"
                > Descargar Planilla Baja Ingles
                </button>
            </div>
        </div>
    );
}

export default planillacambio;
